import{jsx as e,jsxs as t}from"react/jsx-runtime";import m from"tailwind-styled-components";import r from"clsx";import l from"../icon/icon.js";import s from"../paragraph/paragraph.js";const a=m.div``,i=m.div`
  flex
  items-start
`,o=m.div`
  flex-1
`,n=m(s)`
  text-gray-900
  mt-0
  sm:mt-0
  xl:mt-0
  lg:mt-0
  font-medium

  dark:text-gray-100
`,c=m(s)`
  text-slate-500
  text-base

  dark:text-gray-400
`,d=({children:t,className:m,...l})=>e(a,{className:r("list",m),...l,role:"list",children:t}),x=({description:m,className:s,icon:a,iconProps:d,iconSize:x="normal",reverse:p,size:f="normal",title:g})=>{const h="string"==typeof m&&m.trim().length>0,y=r(s,{"flex-row-reverse":p,"my-0":"small"===f,"my-8":"normal"===f,"items-center":!h}),N=r({"md:text-base":"normal"===f,"md:text-sm":"small"===f}),u=r({"md:text-xl":"normal"===f,"md:text-lg":"small"===f,"md:mt-1":"small"===f&&h});return t(i,{className:y,role:"listitem",children:[e(l,{className:"mr-4",background:"#4B4DF1",color:"white",icon:a,size:x,...d}),t(o,{children:[e(n,{className:u,children:g}),e(c,{className:N,children:m})]})]})};x.displayName="List.Item",d.Item=x;export{d as default};
